import { laptopMaxXL } from '@propertypal/shared/src/constants/mediaQueries';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { AgentBox } from '@propertypal/web-ui/src/property/PropertyAgentBox.style';
import { AgentBoxFixed } from '@propertypal/web-ui/src/property/PropertyAgentBoxFixed.style';
import styled from 'styled-components';

export const TopSection = styled.div`
  background-color: ${({ theme }) => theme.backgroundLightest};
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
  padding: 40px 30px;

  @media (${laptopMaxXL}) {
    padding: 15px;
  }
`;

export const LeftPane = styled.div`
  flex: 1;
  max-width: calc(100% - 430px);

  ${AgentBox}, ${AgentBoxFixed} {
    display: none;
  }

  @media (${laptopMaxXL}) {
    flex: 0 0 100%;
    max-width: 100%;

    ${AgentBox} {
      display: block;
      margin: 30px 0;
    }

    ${AgentBoxFixed} {
      display: flex;
    }
  }
`;

export const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 0 0 400px;
  margin-left: 30px;

  @media (${laptopMaxXL}) {
    display: none;
  }
`;

export const StickyAdWrapper = styled.div`
  position: sticky;
  top: 75px;
  left: 0;
`;
